(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-carousel"] && !Shopify.designMode) return;
  try {
    
  class BeforeAfterCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.baf-carousel__viewport');
      this.slides = Array.from(this.querySelectorAll('.baf-carousel__slide'));
      this.prevButton = this.querySelector('.baf-carousel__arrow--prev');
      this.nextButton = this.querySelector('.baf-carousel__arrow--next');
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 4000;
      this.currentIndex = 0;
      this.slideWidth = this.viewport.clientWidth;

      if (this.slides.length < 2) return;

      this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
      this.prevButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      this.viewport.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      window.addEventListener('resize', this.onResize.bind(this), { passive: true });

      if (this.autoplay) this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      clearTimeout(this.scrollDebounce);
      clearTimeout(this.resizeDebounce);
      window.removeEventListener('resize', this.onResize);
    }

    onResize() {
      // Solo se remide el ancho al cambiar de tamaño de viewport (ej. rotar el
      // celular), no en cada scroll/click, para evitar reflow forzado innecesario.
      clearTimeout(this.resizeDebounce);
      this.resizeDebounce = setTimeout(() => {
        this.slideWidth = this.viewport.clientWidth;
      }, 150);
    }

    onScroll() {
      clearTimeout(this.scrollDebounce);
      this.scrollDebounce = setTimeout(() => {
        this.currentIndex = Math.round(this.viewport.scrollLeft / this.slideWidth);
        this.restartAutoplay();
      }, 120);
    }

    goTo(index) {
      const total = this.slides.length;
      this.currentIndex = (index + total) % total;
      this.viewport.scrollTo({
        left: this.currentIndex * this.slideWidth,
        behavior: 'smooth',
      });
    }

    startAutoplay() {
      this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      clearInterval(this.timer);
    }

    restartAutoplay() {
      if (!this.autoplay) return;
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  customElements.define('before-after-carousel', BeforeAfterCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqAccordion extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.faq__question-row');
      this.answer = this.querySelector('.faq__answer');
      this.button.addEventListener('click', this.toggle.bind(this));
    }

    toggle() {
      const isOpen = this.classList.contains('is-open');

      // Solo una pregunta abierta a la vez: cierra las demás del mismo listado.
      this.closest('.faq__list')
        .querySelectorAll('faq-accordion.is-open')
        .forEach((item) => {
          if (item !== this) item.close();
        });

      if (isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.classList.add('is-open');
      this.button.setAttribute('aria-expanded', 'true');
      if (this.answer) this.answer.hidden = false;
    }

    close() {
      this.classList.remove('is-open');
      this.button.setAttribute('aria-expanded', 'false');
      if (this.answer) this.answer.hidden = true;
    }
  }

  customElements.define('faq-accordion', FaqAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewsList extends HTMLElement {
    connectedCallback() {
      this.querySelector('.reviews__show-more')?.addEventListener('click', (event) => {
        this.querySelectorAll('.reviews__item[hidden]').forEach((item) => item.removeAttribute('hidden'));
        event.target.hidden = true;
      });
    }
  }

  customElements.define('reviews-list', ReviewsList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
  class TestimonialCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.testimonial-carousel__viewport');
      this.slides = Array.from(this.querySelectorAll('.testimonial-carousel__slide'));
      this.prevButton = this.querySelector('.testimonial-carousel__arrow--prev');
      this.nextButton = this.querySelector('.testimonial-carousel__arrow--next');
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 4000;
      this.currentIndex = 0;
      this.slideWidth = this.slides[0]?.getBoundingClientRect().width || 0;

      if (this.slides.length < 2) return;

      this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
      this.prevButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      this.viewport.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      window.addEventListener('resize', this.onResize.bind(this), { passive: true });

      if (this.autoplay) this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      clearTimeout(this.scrollDebounce);
      clearTimeout(this.resizeDebounce);
      window.removeEventListener('resize', this.onResize);
    }

    onResize() {
      clearTimeout(this.resizeDebounce);
      this.resizeDebounce = setTimeout(() => {
        this.slideWidth = this.slides[0].getBoundingClientRect().width;
      }, 150);
    }

    onScroll() {
      clearTimeout(this.scrollDebounce);
      this.scrollDebounce = setTimeout(() => {
        this.currentIndex = Math.round(this.viewport.scrollLeft / this.slideWidth);
        this.restartAutoplay();
      }, 120);
    }

    goTo(index) {
      const total = this.slides.length;
      this.currentIndex = (index + total) % total;
      this.viewport.scrollTo({
        left: this.currentIndex * this.slideWidth,
        behavior: 'smooth',
      });
    }

    startAutoplay() {
      this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      clearInterval(this.timer);
    }

    restartAutoplay() {
      if (!this.autoplay) return;
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  customElements.define('testimonial-carousel', TestimonialCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  class VideoCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.video-carousel__viewport');
      this.slides = Array.from(this.querySelectorAll('.video-carousel__slide'));
      this.prevButton = this.querySelector('.video-carousel__arrow--prev');
      this.nextButton = this.querySelector('.video-carousel__arrow--next');
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 4000;
      this.currentIndex = 0;
      this.slideWidth = this.slides[0]?.getBoundingClientRect().width || 0;

      if (this.slides.length < 2) return;

      this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
      this.prevButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      this.viewport.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      window.addEventListener('resize', this.onResize.bind(this), { passive: true });

      if (this.autoplay) this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      clearTimeout(this.scrollDebounce);
      clearTimeout(this.resizeDebounce);
      window.removeEventListener('resize', this.onResize);
    }

    onResize() {
      clearTimeout(this.resizeDebounce);
      this.resizeDebounce = setTimeout(() => {
        this.slideWidth = this.slides[0].getBoundingClientRect().width;
      }, 150);
    }

    onScroll() {
      clearTimeout(this.scrollDebounce);
      this.scrollDebounce = setTimeout(() => {
        this.currentIndex = Math.round(this.viewport.scrollLeft / this.slideWidth);
        this.pauseOtherVideos();
        this.restartAutoplay();
      }, 120);
    }

    goTo(index) {
      const total = this.slides.length;
      this.currentIndex = (index + total) % total;
      this.viewport.scrollTo({
        left: this.currentIndex * this.slideWidth,
        behavior: 'smooth',
      });
      this.pauseOtherVideos();
    }

    pauseOtherVideos() {
      // Evita que un video con sonido siga sonando de fondo tras deslizar a otro.
      this.slides.forEach((slide, i) => {
        if (i === this.currentIndex) return;
        slide.querySelectorAll('video').forEach((video) => video.pause());
      });
    }

    startAutoplay() {
      this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      clearInterval(this.timer);
    }

    restartAutoplay() {
      if (!this.autoplay) return;
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  customElements.define('video-carousel', VideoCarousel);

  } catch(e) { console.error(e); }
})();
})();
